import { pubsub } from './pubsub';
import { homepageUi, addProjectsToUI, loadProjectListAtLoad, processSelectedProject, processTasksRendered, processTaskInfoForModal, displayAllTasksOnLoad } from "./homepage-ui";
import Projects from "./projects";
import Tasks from './tasksfactory';
import { addProject } from './projects-form';
import { addProjectToLocalStorage, processProjectDelete, retrieveLocalStorage, saveProjectToLocalStorage, processTaskAdded, projectSelected, processChangeTaskStatus, processChangeTaskDate, processTaskDetailsModal, processOpenPrefilledTaskModal, processTaskEdited, processDeleteTaskRequest, processRequestAllTasksStored, processRequestImportantTasks, processRequestTodaysTasks, processRequestWeekTasks } from './local-storage';
import { renderProjects, processLocalStorage, deleteProject } from './projects-render';
import { processAddTaskButton, processTaskInfoForEditModal } from './tasks-form';
import { processTaskStored, processTasksFiltered } from './tasks-render';
import { createSampleProject } from './sample-project';
import './styles/styles.css';
import './styles/normalize.css';

// create a sample project
createSampleProject();

// render the homepage UI
homepageUi();

// opens form to add a project
addProject();

// adds to localStorage the project info
// entered in the project form
addProjectToLocalStorage();

// processes localStorage and sends back info for the UI
processLocalStorage();
addProjectsToUI();

// deletes the project info from localStorage
processProjectDelete();

// delete a project button
deleteProject();

// make the list of projects in localStorage available on page load
retrieveLocalStorage();

// make selected project appear in the content area
processSelectedProject();

// display the addTask button when the project is selected
processAddTaskButton();

// add and store tasks to a project
processTaskAdded();
processTaskStored();

// render tasks when accessed through sidebar filters
processTasksFiltered();

// adds the fragment with tasks rendered to the main area in the UI
processTasksRendered();

// functions related to task operations
projectSelected();
processChangeTaskStatus();
processChangeTaskDate();
processTaskDetailsModal();
processTaskInfoForModal();

// edit task from ui button
processOpenPrefilledTaskModal();
processTaskInfoForEditModal();
processTaskEdited();

// delete a task from the ui button
processDeleteTaskRequest();

// load tasks on DOMContentLoaded
displayAllTasksOnLoad();
processRequestAllTasksStored();

// load Important tasks on filter click
processRequestImportantTasks();

// load Today's tasks
processRequestTodaysTasks();

// load this week's tasks
processRequestWeekTasks();
